"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inc = exports.prerelease = exports.patch = exports.minor = exports.major = exports.valid = void 0;
const semver_1 = require("./go/semver");
function valid(v) {
    return (0, semver_1.isValid)(v);
}
exports.valid = valid;
function major(v) {
    try {
        return (0, semver_1.parse)(v).major;
    }
    catch (e) {
        return null;
    }
}
exports.major = major;
function minor(v) {
    try {
        return (0, semver_1.parse)(v).minor;
    }
    catch (e) {
        return null;
    }
}
exports.minor = minor;
function patch(v) {
    try {
        return (0, semver_1.parse)(v).patch;
    }
    catch (e) {
        return null;
    }
}
exports.patch = patch;
function prerelease(v) {
    try {
        // remove leading '-' from prerelease
        return (0, semver_1.parse)(v).prerelease.substring(1);
    }
    catch (e) {
        return null;
    }
}
exports.prerelease = prerelease;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function inc(v) {
    throw new Error('Not implemented');
}
exports.inc = inc;
//# sourceMappingURL=functions.js.map